var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82051 0V9.46702L4.2273 6.98037L3.44578 7.79741L7.38889 11.5851L11.332 7.79741L10.5505 6.98037L7.95726 9.46702V1.1383e-05L6.82051 0ZM0 10.2308V13.0726C0 14.0096 0.768194 14.7778 1.70513 14.7778H13.0726C14.0096 14.7778 14.7778 14.0096 14.7778 13.0726V10.2308H13.641V13.0726C13.641 13.3924 13.3924 13.641 13.0726 13.641H1.70513C1.38542 13.641 1.13675 13.3924 1.13675 13.0726V10.2308H0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e481970fa46f6c64b64d6245d1372027.svg";
export { ForwardRef as ReactComponent };